import Location from "./location";
import ApiKeys from "./apiKeys";
import Utility from "../helpers/utility";
import { ORDER_TYPE } from "../helpers/paymentConstants";
import store from "../store/index";
import LocalStorageFunc from "../helpers/localStorageFunc";
import { isCorporateSite, isDesktop, IS_INDIA } from "./apiEndpoints";

const headers = (payload, addtionalHeader = false) => {  
  let headers = {
    api_key: ApiKeys.API_KEY,
    client_type: ApiKeys.clientType,
  };

  const queryObj = Utility.getQueryFromUrlWithSpace(window.location.href);
  const assetName = queryObj["platform"];
  const cateogryTypeDineInTakeAway =
    window.location.href.includes("/qr") &&
    Utility.getLinkRewriteFromSiteprops() === "qr" &&
    ((queryObj["ordertype"] || queryObj["orderType"])?.toUpperCase() ||
      ORDER_TYPE.DINEIN);

  if (assetName) {
    headers.api_key = ApiKeys.APP_API_KEY || ApiKeys.API_KEY;
  }

  let credentials = localStorage.userInfo
    ? Utility.tryJsonParse(localStorage.userInfo)?.headers?.credentials
    : "";

  let value = localStorage.userInfo
    ? Utility.tryJsonParse(localStorage.userInfo)?.headers
    : "";

  headers["X-FORWARDED-FOR-requestId"] = value.isLoggedIn 
    ? `pwa-${value?.userId}-${new Date().getTime()}`
    : `pwa-anon-${value?.userId}-${new Date().getTime()}`;

  const regex = /[\{\}]/;
  if (value && !value.isLoggedIn) {
    if (credentials) {
      for (const [key, val] of Object.entries(credentials)) {
        headers[key.toLowerCase()] = val;
      }
      if (credentials?.accessKeyId && !regex.test(credentials?.accessKeyId)) {
        headers["authtoken"] = credentials.accessKeyId;
      }
    }
  } else {
    if (credentials?.accessKeyId && !regex.test(credentials?.accessKeyId)) {
      headers["authtoken"] = credentials.accessKeyId;
    }
  }

  const source_name = !isDesktop ? "PWA18" : "NewDesktop";
  if (value) {
    headers["source"] = source_name;
  }

  if (value && value.isLoggedIn) {
    headers["isloggedin"] = true;
  } else {
    headers["isloggedin"] = false;
  }
  value = localStorage.userInfo
    ? Utility.tryJsonParse(localStorage.userInfo)?.headers?.userId
    : "";
  if (value) {
    headers["userid"] = value;
  }

  value = localStorage.lastLocationNew
    ? Utility.tryJsonParse(localStorage.lastLocationNew)[0]?.recent
        ?.advanceOrderStoreId ||
      Utility.tryJsonParse(localStorage.lastLocationNew)[0]?.recent?.id
    : "";
  if (value) {
    headers["storeid"] = value;
  } else {
    let __ = localStorage.storeId || "";
    if (__) {
      headers["storeid"] = __;
    } else {
      headers["storeid"] = Location.defaultStoreId;
      localStorage.storeId = Location.defaultStoreId;
    }
  }
  if (cateogryTypeDineInTakeAway) {
    headers["storeid"] =
      queryObj.storeid || queryObj.storeId || Location.defaultStoreId;
  }
  value = localStorage.userInfo
    ? Utility.tryJsonParse(localStorage.userInfo)?.headers?.cartId
    : "";
  if (value) {
    headers["cartid"] = value;
  }

  value = localStorage.userInfo
    ? Utility.tryJsonParse(localStorage.userInfo)?.headers?.deliveryType
    : "";
  if (value) {
    headers["deliverytype"] = cateogryTypeDineInTakeAway
      ? cateogryTypeDineInTakeAway?.toUpperCase()
      : value;
  }

  if (payload && payload.withRefreshToken) {
    value = localStorage.userInfo
      ? Utility.tryJsonParse(localStorage.userInfo)?.headers?.credentials
          ?.refreshToken
      : "";
    if (value) {
      headers["refreshtoken"] = value;
    }
  }

  if (addtionalHeader) {
    const temp = {
      ...headers,
      ...payload.addtionalHeader,
    };

    headers = temp;
  }

  const childStoreId =
    store.state.Location.childStoreId ||
    localStorage.getItem("CHILD_STORE_ID_IS");
  if (
    headers["deliverytype"] == "D" &&
    childStoreId != undefined &&
    childStoreId != "undefined" &&
    childStoreId != "null" &&
    childStoreId
  ) {
    headers["childStoreId"] = childStoreId;
  }

  const userLocationData = LocalStorageFunc.getUserLocationData();

  const { latitude = "", longitude = "" } = userLocationData?.location || {};
  if(IS_INDIA){
    headers["u_lat"] = latitude;
    headers["u_long"] = longitude;
    headers["getstoreloyaltyprogramcode"] = true;
  }

  if (headers?.accesskeyid && regex.test(headers?.accesskeyid)) {
    delete headers.accesskeyid;
  }
  if (headers?.secretkey && regex.test(headers?.secretkey)) {
    delete headers.secretkey;
  }

  if (isCorporateSite) {
    const corporateUserInfo = LocalStorageFunc.getCorporateUserInfo();
    headers["isCorporateOrder"] = true;
    if (corporateUserInfo?.headers?.isCorporateLoggedIn) {
      headers["emailId"] = corporateUserInfo?.userData?.email;
      headers["LdapAccessToken"] = corporateUserInfo?.headers?.LdapAccessToken;
    }
    headers["X-FORWARDED-FOR-requestId"] = `corporate-${corporateUserInfo?.userData?.userId}-${new Date().getTime()}`;
  }

  return headers;
};

export default headers;
